import React from 'react';

const Button = ({ onClick, text, className = '', type = 'button', color = 'primary' }) => {
  const baseClasses = 'inline-flex items-center justify-center px-6 py-3 text-lg shadow-xl rounded-xl transition-colors duration-200';
  const colorClasses = color === 'primary'
    ? 'button-primary'
    : 'button-secondary';

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${colorClasses} ${className}`}
    >
      {text}
    </button>
  );
};

export default Button;
